exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slide-indicator{position:absolute;left:40px;top:50%;transform:translateY(-50%);font-family:SorrenMedium;text-transform:uppercase;font-size:22px;text-align:center;visibility:hidden}.slide-indicator__separator{display:inline-block;width:1px;height:2.4em;margin:0 .3em;transform-origin:center}.slide-indicator__slider-length{display:inline-block;font-size:1.5em}.slide-indicator__current-slide{display:inline-block;vertical-align:bottom;font-size:3em;width:.2em}.slide-indicator__slider-name{margin-top:.4em;letter-spacing:.07em}.slide-indicator__slider-name__splitted{display:inline-block;white-space:pre}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6c9fa241!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/Slider/SlideIndicator.vue
// module id = 122
// module chunks = 0